import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject();
    minDateChannel = new Subject();
    checkDateChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.minDateChannel.next({status: apiResponse.INITIAL})
        this.checkDateChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchMinDate = async (query) => {
        try {
            this.minDateChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchMinDate(query).then((result) => {
                this.minDateChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.minDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchCheckDate = async (query) => {
        try {
            this.checkDateChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchCheckDate(query).then((result) => {
                this.checkDateChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default CreateBloc